/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { HTTPValidationError, UserFeedback } from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to submit user feedback.

This will handle what to do with the feedback depending on the type.
 * @summary New Feedback
 */
export const newFeedback = (
  userFeedback: UserFeedback,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/feedback/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userFeedback,
    signal,
  });
};

export const getNewFeedbackMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof newFeedback>>,
    TError,
    { data: UserFeedback },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof newFeedback>>,
  TError,
  { data: UserFeedback },
  TContext
> => {
  const mutationKey = ["newFeedback"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof newFeedback>>,
    { data: UserFeedback }
  > = (props) => {
    const { data } = props ?? {};

    return newFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NewFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof newFeedback>>
>;
export type NewFeedbackMutationBody = UserFeedback;
export type NewFeedbackMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary New Feedback
 */
export const useNewFeedback = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof newFeedback>>,
      TError,
      { data: UserFeedback },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof newFeedback>>,
  TError,
  { data: UserFeedback },
  TContext
> => {
  const mutationOptions = getNewFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
